import { post } from "../../helpers/utils/http-client";
import { API_PREFIX } from "../../consts/api-endpoints";

// API Gateway rejects request bodies over 10 MB, and base64 inflates by ~4/3.
// Checked here so an oversized file is reported before it is read and sent,
// rather than as an opaque network failure.
export const MAX_UPLOAD_BYTES = 7 * 1024 * 1024;

/**
 * Read a File into a base64 string (no data: prefix).
 *
 * readAsDataURL is used rather than readAsArrayBuffer because the browser does
 * the base64 encoding itself; encoding a large ArrayBuffer by hand in JS is
 * slow and risks blowing the call stack on String.fromCharCode(...bytes).
 */
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = String(reader.result || '');
            const comma = result.indexOf(',');
            resolve(comma === -1 ? result : result.slice(comma + 1));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
}

/**
 * Upload one document as base64.
 *
 * Authenticated with the same access key the widget uses for chatting, so a
 * visitor never needs credentials of their own. The backend decodes the payload
 * and stores the file; only the returned key travels on as the step's answer.
 */
export async function uploadDocument(appId, accessKey, sessionId, file) {
    try {
        if (file.size > MAX_UPLOAD_BYTES) {
            return { error: 'too_large' };
        }

        const fileExt = (file.name || '').split('.').pop().toLowerCase();
        const fileData = await fileToBase64(file);

        const { response, status } = await post(
            `${API_PREFIX}/apps/${appId}/runtime/doc-capture/upload`,
            { sessionId, fileName: file.name, fileExt, fileData },
            { 'Authorization': accessKey }
        );

        if (status !== 200 || !(response && response.fileKey)) {
            return { error: 'failed' };
        }

        return {
            fileKey: response.fileKey,
            fileName: response.fileName || file.name,
            size: response.size
        };
    } catch (err) {
        console.debug('uploadDocument failed cause', err.message, err.code);
        return { error: 'failed' };
    }
}
